import { __module as D } from "./index.es345.js";
var $;
function K() {
  return $ ? D.exports : ($ = 1, (() => {
    typeof __nccwpck_require__ < "u" && (__nccwpck_require__.ab = __dirname + "/");
    var S = {};
    (() => {
      var l = S;
      Object.defineProperty(l, "__esModule", { value: !0 }), l.pathToRegexp = l.tokensToRegexp = l.regexpToFunction = l.match = l.tokensToFunction = l.compile = l.parse = void 0;
      function j(r) {
        for (var t = [], e = 0; e < r.length; ) {
          var o = r[e];
          if (o === "*" || o === "+" || o === "?") {
            t.push({ type: "MODIFIER", index: e, value: r[e++] });
            continue;
          }
          if (o === "\\") {
            t.push({ type: "ESCAPED_CHAR", index: e++, value: r[e++] });
            continue;
          }
          if (o === "{") {
            t.push({ type: "OPEN", index: e, value: r[e++] });
            continue;
          }
          if (o === "}") {
            t.push({ type: "CLOSE", index: e, value: r[e++] });
            continue;
          }
          if (o === ":") {
            for (var u = "", a = e + 1; a < r.length; ) {
              var i = r.charCodeAt(a);
              if (i >= 48 && i <= 57 || i >= 65 && i <= 90 || i >= 97 && i <= 122 || i === 95) {
                u += r[a++];
                continue;
              }
              break;
            }
            if (!u) throw new TypeError("Missing parameter name at ".concat(e));
            t.push({ type: "NAME", index: e, value: u }), e = a;
            continue;
          }
          if (o === "(") {
            var f = 1, v = "", a = e + 1;
            if (r[a] === "?")
              throw new TypeError('Pattern cannot start with "?" at '.concat(a));
            for (; a < r.length; ) {
              if (r[a] === "\\") {
                v += r[a++] + r[a++];
                continue;
              }
              if (r[a] === ")") {
                if (f--, f === 0) {
                  a++;
                  break;
                }
              } else if (r[a] === "(" && (f++, r[a + 1] !== "?"))
                throw new TypeError("Capturing groups are not allowed at ".concat(a));
              v += r[a++];
            }
            if (f) throw new TypeError("Unbalanced pattern at ".concat(e));
            if (!v) throw new TypeError("Missing pattern at ".concat(e));
            t.push({ type: "PATTERN", index: e, value: v }), e = a;
            continue;
          }
          t.push({ type: "CHAR", index: e, value: r[e++] });
        }
        return t.push({ type: "END", index: e, value: "" }), t;
      }
      function k(r, t) {
        t === void 0 && (t = {});
        for (var e = j(r), o = t.prefixes, u = o === void 0 ? "./" : o, a = t.delimiter, i = a === void 0 ? "/#?" : a, f = [], v = 0, s = 0, p = "", n = function(w) {
          if (s < e.length && e[s].type === w) return e[s++].value;
        }, d = function(w) {
          var h = n(w);
          if (h !== void 0) return h;
          var R = e[s], F = R.type, G = R.index;
          throw new TypeError("Unexpected ".concat(F, " at ").concat(G, ", expected ").concat(w));
        }, x = function() {
          for (var w = "", h; h = n("CHAR") || n("ESCAPED_CHAR"); )
            w += h;
          return w;
        }, _ = function(w) {
          for (var h = 0, R = i; h < R.length; h++) {
            var F = R[h];
            if (w.indexOf(F) > -1) return !0;
          }
          return !1;
        }, T = function(w) {
          var h = f[f.length - 1], R = w || (h && typeof h == "string" ? h : "");
          if (h && !R)
            throw new TypeError('Must have text between two parameters, missing text after "'.concat(h.name, '"'));
          return !R || _(R) ? "[^".concat(E(i), "]+?") : "(?:(?!".concat(E(R), ")[^").concat(E(i), "])+?");
        }; s < e.length; ) {
          var m = n("CHAR"), g = n("NAME"), b = n("PATTERN");
          if (g || b) {
            var y = m || "";
            u.indexOf(y) === -1 && (p += y, y = ""), p && (f.push(p), p = ""), f.push({ name: g || v++, prefix: y, suffix: "", pattern: b || T(y), modifier: n("MODIFIER") || "" });
            continue;
          }
          var c = m || n("ESCAPED_CHAR");
          if (c) {
            p += c;
            continue;
          }
          p && (f.push(p), p = "");
          var C = n("OPEN");
          if (C) {
            var y = x(), A = n("NAME") || "", O = n("PATTERN") || "", P = x();
            d("CLOSE"), f.push({ name: A || (O ? v++ : ""), pattern: A && !O ? T(y) : O, prefix: y, suffix: P, modifier: n("MODIFIER") || "" });
            continue;
          }
          d("END");
        }
        return f;
      }
      l.parse = k;
      function L(r, t) {
        return H(k(r, t), t);
      }
      l.compile = L;
      function H(r, t) {
        t === void 0 && (t = {});
        var e = M(t), o = t.encode, u = o === void 0 ? function(v) {
          return v;
        } : o, a = t.validate, i = a === void 0 ? !0 : a, f = r.map((function(v) {
          if (typeof v == "object")
            return new RegExp("^(?:".concat(v.pattern, ")$"), e);
        }));
        return function(v) {
          for (var s = "", p = 0; p < r.length; p++) {
            var n = r[p];
            if (typeof n == "string") {
              s += n;
              continue;
            }
            var d = v ? v[n.name] : void 0, x = n.modifier === "?" || n.modifier === "*", _ = n.modifier === "*" || n.modifier === "+";
            if (Array.isArray(d)) {
              if (!_)
                throw new TypeError('Expected "'.concat(n.name, '" to not repeat, but got an array'));
              if (d.length === 0) {
                if (x) continue;
                throw new TypeError('Expected "'.concat(n.name, '" to not be empty'));
              }
              for (var T = 0; T < d.length; T++) {
                var m = u(d[T], n);
                if (i && !f[p].test(m))
                  throw new TypeError('Expected all "'.concat(n.name, '" to match "').concat(n.pattern, '", but got "').concat(m, '"'));
                s += n.prefix + m + n.suffix;
              }
              continue;
            }
            if (typeof d == "string" || typeof d == "number") {
              var m = u(String(d), n);
              if (i && !f[p].test(m))
                throw new TypeError('Expected "'.concat(n.name, '" to match "').concat(n.pattern, '", but got "').concat(m, '"'));
              s += n.prefix + m + n.suffix;
              continue;
            }
            if (!x) {
              var g = _ ? "an array" : "a string";
              throw new TypeError('Expected "'.concat(n.name, '" to be ').concat(g));
            }
          }
          return s;
        };
      }
      l.tokensToFunction = H;
      function U(r, t) {
        var e = [], o = N(r, e, t);
        return I(o, e, t);
      }
      l.match = U;
      function I(r, t, e) {
        e === void 0 && (e = {});
        var o = e.decode, u = o === void 0 ? function(a) {
          return a;
        } : o;
        return function(a) {
          var i = r.exec(a);
          if (!i) return !1;
          for (var f = i[0], v = i.index, s = /* @__PURE__ */ Object.create(null), p = function(d) {
            if (i[d] === void 0) return "continue";
            var x = t[d - 1];
            x.modifier === "*" || x.modifier === "+" ? s[x.name] = i[d].split(x.prefix + x.suffix).map((function(_) {
              return u(_, x);
            })) : s[x.name] = u(i[d], x);
          }, n = 1; n < i.length; n++)
            p(n);
          return { path: f, index: v, params: s };
        };
      }
      l.regexpToFunction = I;
      function E(r) {
        return r.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
      }
      function M(r) {
        return r && r.sensitive ? "" : "i";
      }
      function W(r, t) {
        if (!t) return r;
        for (var e = /\((?:\?<(.*?)>)?(?!\?)/g, o = 0, u = e.exec(r.source); u; )
          t.push({ name: u[1] || o++, prefix: "", suffix: "", modifier: "", pattern: "" }), u = e.exec(r.source);
        return r;
      }
      function z(r, t, e) {
        var o = r.map((function(u) {
          return N(u, t, e).source;
        }));
        return new RegExp("(?:".concat(o.join("|"), ")"), M(e));
      }
      function B(r, t, e) {
        return q(k(r, e), t, e);
      }
      function q(r, t, e) {
        e === void 0 && (e = {});
        for (var o = e.strict, u = o === void 0 ? !1 : o, a = e.start, i = a === void 0 ? !0 : a, f = e.end, v = f === void 0 ? !0 : f, s = e.encode, p = s === void 0 ? function(h) {
          return h;
        } : s, n = e.delimiter, d = n === void 0 ? "/#?" : n, x = e.endsWith, _ = x === void 0 ? "" : x, T = "[".concat(E(_), "]|$"), m = "[".concat(E(d), "]"), g = i ? "^" : "", b = 0, y = r; b < y.length; b++) {
          var c = y[b];
          if (typeof c == "string")
            g += E(p(c));
          else {
            var C = E(p(c.prefix)), A = E(p(c.suffix));
            if (c.pattern)
              if (t && t.push(c), C || A)
                if (c.modifier === "+" || c.modifier === "*") {
                  var O = c.modifier === "*" ? "?" : "";
                  g += "(?:".concat(C, "((?:").concat(c.pattern, ")(?:").concat(A).concat(C, "(?:").concat(c.pattern, "))*)").concat(A, ")").concat(O);
                } else
                  g += "(?:".concat(C, "(").concat(c.pattern, ")").concat(A, ")").concat(c.modifier);
              else {
                if (c.modifier === "+" || c.modifier === "*")
                  throw new TypeError('Can not repeat "'.concat(c.name, '" without a prefix and suffix'));
                g += "(".concat(c.pattern, ")").concat(c.modifier);
              }
            else
              g += "(?:".concat(C).concat(A, ")").concat(c.modifier);
          }
        }
        if (v)
          u || (g += "".concat(m, "?")), g += e.endsWith ? "(?=".concat(T, ")") : "$";
        else {
          var P = r[r.length - 1], w = typeof P == "string" ? m.indexOf(P[P.length - 1]) > -1 : P === void 0;
          u || (g += "(?:".concat(m, "(?=").concat(T, "))?")), w || (g += "(?=".concat(m, "|").concat(T, ")"));
        }
        return new RegExp(g, M(e));
      }
      l.tokensToRegexp = q;
      function N(r, t, e) {
        return r instanceof RegExp ? W(r, t) : Array.isArray(r) ? z(r, t, e) : B(r, t, e);
      }
      l.pathToRegexp = N;
    })(), D.exports = S;
  })(), D.exports);
}
export {
  K as __require
};
//# sourceMappingURL=index.es334.js.map
